module.exports = __webpack_public_path__ + "img/success.e205c96c.png";